module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list-shades row"
  }, [_c('loader', {
    attrs: {
      "position": 'fixed',
      "spinLeft": '60%',
      "loading": _vm.isLoader
    }
  }), _vm._v(" "), _vm._l((_vm.dataShades), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "col-lg-3 col-md-3 col-xs-6 list-shades-bloc",
      class: {
        noBorder: Number((key + 1) / 4) % 1 === 0
      }
    }, [_c('figure', {
      staticClass: "list-shades-figure"
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "to": '/product/' + item.component.id + '?refere=shades'
      }
    }, [(!item.component.figures.small) ? _c('img', {
      staticClass: "grab img-fluid ff-medium svgMeuble center",
      attrs: {
        "src": require("../../../static/img/no_image.jpg")
      }
    }) : _vm._e(), _vm._v(" "), (item.component.figures.small) ? _c('img', {
      attrs: {
        "src": _vm.getImgPath(item.component.figures.small)
      }
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "bgColor",
      style: (item.properties.colors ? {
        'background-color': item.properties.colors.color.value
      } : '')
    }, [(!item.properties.colors) ? _c('i', {
      staticClass: "far fa-empty-set"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "detailShade"
    }, [_c('h3', {
      staticClass: "titleShade"
    }, [_vm._v(_vm._s(_vm.getTranslate(item.component.terms.name)))]), _vm._v(" "), _c('p', {
      staticClass: "refShade"
    }, [(item.properties.number) ? _c('span', [_vm._v(_vm._s(item.properties.number.numb1.value))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("- " + _vm._s(item.terms.name ? _vm.getTranslate(item.terms.name) : item.name))]), _vm._v(" "), _c('span', {
      staticClass: "block"
    }, [_vm._v("(" + _vm._s(item.properties.reference.client_ref1.value) + ")")])])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0308f133","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shades/listShades.vue
// module id = 2983
// module chunks = 0